/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var KonturBonusSignIcon20Regular = forwardRef('KonturBonusSignIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5 1.5a.75.75 0 0 0-1.5 0V4H6.4A1.4 1.4 0 0 0 5 5.4v9.2A1.4 1.4 0 0 0 6.4 16H9v2.5a.75.75 0 0 0 1.5 0V16h.75a3.5 3.5 0 1 0 0-7H6.5V5.5h6.75a.75.75 0 0 0 0-1.5H10.5V1.5Zm-4 13v-4h4.75a2 2 0 1 1 0 4H6.5Z" })));
});
